export default {
      id: "configure-statements-usage",
      viewBox: "0 0 160 160",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#configure-statements",
      toString: function () {
        return this.url;
      }
    }